import type { PaginatorDesignTokens, PaginatorTokenSections } from '@openng/optimus-ui-themes/types/paginator';

export const root: PaginatorTokenSections.Root = {
	padding: '{pagination.padding}',
	gap: '{pagination.gap}',
};

export const jumpToPageInput: PaginatorTokenSections.JumpToPageInput = {
	maxWidth: '0.25rem',
};

export default {
	root,
	jumpToPageInput,
} satisfies PaginatorDesignTokens;
